import { EPostbackStatus } from '../types'

export const POSTBACK_STATUS_COLORS_MAP: Record<EPostbackStatus, string> = {
	[EPostbackStatus.Lead]: 'bg-warning',
	[EPostbackStatus.Sale]: 'bg-success',
	[EPostbackStatus.Reject]: 'bg-danger',
}